import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import CompanyCards from "components/Outdoor_Cameras/IN-9808_QFHD/Warranty/CompanyCards";
import WeeSymbol from "components/Outdoor_Cameras/IN-9808_QFHD/Warranty/faq01Image";
import NavButtons from "components/Outdoor_Cameras/IN-9808_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-9808 4K (QFHD) Handbuch Garantie & Entsorgung",
  "path": "/Aussenkameras/IN-9808_QFHD/Garantie/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die IN-9808 4K (QFHD) ist die erste INSTAR-Kamera mit dem neuen 2160p-Chipsatz.",
  "image": "./P_SearchThumb_IN-9008HD_Warranty.png",
  "social": "/images/Search/P_SearchThumb_IN-9408WQHD_Warranty.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title="IN-9808 4K (QFHD) Handbuch Garantie & Entsorgung" dateChanged="2017-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="Die IN-9808 4K (QFHD) ist die erste INSTAR IP-Überwachungskamera für den Außenbereich, die unseren neuen Sony 2160p / QFHD STARVIS Sensor verwendet." image="/images/Search/P_SearchThumb_IN-9408HD_Warranty.png" twitter="/images/Search/P_SearchThumb_IN-9408HD_Warranty.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9808_QFHD/Warranty/" locationFR="/fr/Outdoor_Cameras/IN-9808_QFHD/Warranty/" crumbLabel="Warranty" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "in-9808-4k-qfhd-garantie--entsorgung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-9808-4k-qfhd-garantie--entsorgung",
        "aria-label": "in 9808 4k qfhd garantie  entsorgung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-9808 4K (QFHD) Garantie & Entsorgung`}</h2>
    <h3 {...{
      "id": "2-jahre-beschränkte-garantie",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#2-jahre-beschr%C3%A4nkte-garantie",
        "aria-label": "2 jahre beschränkte garantie permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`2 Jahre beschränkte Garantie`}</h3>
    <p>{`INSTAR bietet eine 2-jährige Garantie auf seine Produkte. Während dieser Zeit können Sie Ihre Kamera für eine kostenlose Reparatur einschicken. Davon ausgenommen sind Kameras, die mit einer von INSTAR nicht freigegebenen Firmware oder WebUIs von Drittanbietern installiert wurden. Die Garantie bezieht sich nur auf die Hardwareteile der Kamera. Wenn Sie sich an unser Serviceteam wenden, halten Sie bitte Ihre Modell- und Seriennummer bereit. Wenn Sie Ihre Kamera zur Reparatur einschicken möchten, verwenden Sie bitte das RMA-Formular, das Sie mit Ihrer Kamera erhalten haben. Sie können es auch von unserer Website instar.de herunterladen oder das INSTAR Service Team kontaktieren:`}</p>
    <CompanyCards mdxType="CompanyCards" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "general-public-license",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#general-public-license",
        "aria-label": "general public license permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`General Public License`}</h3>
    <p><strong parentName="p">{`Dieses Produkt enthält Softwareprogramme, die der GPL-Lizenz für freie Software unterliegen`}</strong></p>
    <p>{`Dieses Produkt enthält Software, die von Dritten entwickelt wurde und/oder Software, die der GNU General Public License (GPL) und/oder der GNU Lesser General Public License (LGPL) unterliegt. Den Quellcode dieser Programme senden wir Ihnen auf Anfrage gerne zu. Der in diesem Produkt verwendete und angebotene GPL- und/oder LGPL-Code ist EXKLUSIV JEGLICHER GARANTIE und unterliegt dem Copyright eines oder mehrerer Autoren. Weitere Einzelheiten entnehmen Sie bitte dem GPL- und/oder LGPL-Code dieses Produkts sowie den Nutzungsbedingungen der GPL und LGPL.`}</p>
    <p>{`Sie können den vollständigen Lizenztext lesen unter `}<OutboundLink href="http://www.gnu.org/licenses/gpl-2.0.html" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink"><a parentName="p" {...{
          "href": "http://www.gnu.org"
        }}>{`www.gnu.org`}</a></OutboundLink>{`.`}</p>
    <h3 {...{
      "id": "entsorgung-von-elektroaltgeräten",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#entsorgung-von-elektroaltger%C3%A4ten",
        "aria-label": "entsorgung von elektroaltgeräten permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Entsorgung von Elektroaltgeräten`}</h3>
    <p><strong parentName="p">{`Elektro- und Elektronik-Altgeräte`}</strong></p>
    <WeeSymbol mdxType="WeeSymbol" />
    <p>{`Die europäische Richtlinie 2002/96/EG über Elektro- und Elektronik-Altgeräte (WEEE) schreibt vor, dass Elektroaltgeräte nicht über den normalen, unsortierten Siedlungsabfall entsorgt werden dürfen. Altgeräte müssen getrennt gesammelt werden, um die Rückgewinnung und das Recycling der in ihnen enthaltenen Materialien zu optimieren und die Auswirkungen auf die menschliche Gesundheit und die Umwelt zu verringern.`}</p>
    <p>{`Die durchgestrichene Mülltonne" auf dem Produkt erinnert Sie an Ihre Verpflichtung, das Gerät getrennt zu sammeln, wenn Sie es entsorgen. Die Verbraucher sollten sich an ihre Gemeindeverwaltung oder ihren Händler wenden, um Informationen über die korrekte Entsorgung ihres Altgeräts zu erhalten.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      